export class StoreRole {
    public RoleName: string;
    public Description: string;
    public Disabled: number;
    public State: RoleState;
}
export enum RoleState {
    Unchanged = 0,
    Added = 1,
    Deleted = 2,
}
